<template>
    <div v-if="item" style="padding-top:10px;padding-bottom:10px;">
        <a href="javascript:void(0);" title="Link Work Item" class="btn btn-sm btn-warning" 
            @click="linkWorkItem(item)"><i class="fa fa-link"></i>&nbsp;Link</a>
    </div>
</template>
<style scoped>
    
</style>
<script>
import Vue from "vue";
import CommonFactory from '@/mixins/common.factory';
export default Vue.extend({
    mixins:[CommonFactory],
    data() {
        return {
            type:'',
            val:null,
            item:null
        }
    },
    created(){
        let _self=this;
        _self.val=_self.params.value;
        _self.item=_self.params.data;
    },
    methods:{
        linkWorkItem(e){
            const _self=this;
            _self.params.context.componentParent.extraCallBackFn(_self.params);
        },
    }
});
</script>
